import { Trans } from 'react-i18next';

import { Button } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useNavigation } from '@/hooks/navigation';
import { useIsLanding } from '@/hooks/useIsLanding';
import { useModalsStore } from '@/store';

import { ScRegistrationInfo } from '../styled';

export const FormFooter = () => {
  const { navigate } = useNavigation();
  const open = useModalsStore.use.open();
  const { isLanding } = useIsLanding();

  const handleOpenLoginModal = () => {
    if (isLanding) return navigate('/?modal=login');

    open(Modals.Login);
  };

  return (
    <ScRegistrationInfo>
      <Trans i18nKey="common:auth.registration.infoText">
        Already have an account?
        <Button link onClick={handleOpenLoginModal}>
          Login
        </Button>
      </Trans>
    </ScRegistrationInfo>
  );
};
